import { toast } from '@livable/saas-react-components';
import { succeeded } from './asyncResult';
import { findCreatedPropertyUtility } from './credentialStatus';
import { notifyCredentialsChanged } from './credentialEvents';
const SAVE_FAILED = 'The utility was saved, but its credentials were not. Add them from the property utility list.';

/**
 * Save a credential typed during an ADD flow, once the property utility actually exists.
 *
 * Shared by all three "add utility" modals. The create endpoints do not hand back the new
 * propertyUtilityId, so it is resolved by re-reading the property's utilities. If it cannot be
 * resolved we say so rather than writing an unscoped credential that no property page could ever
 * find again - and the utility itself is already saved either way, so this never rolls anything back.
 *
 * The caller owns the secret's lifetime: pass a snapshot and clear your own state immediately,
 * because this runs after the modal has started closing.
 */
export const savePendingCredential = async _ref => {
  var _pending$username;
  let store = _ref.store,
    pending = _ref.pending,
    companyId = _ref.companyId,
    propertyId = _ref.propertyId,
    utilityProviderId = _ref.utilityProviderId,
    utilityTypeId = _ref.utilityTypeId;
  if (!(pending !== null && pending !== void 0 && (_pending$username = pending.username) !== null && _pending$username !== void 0 && _pending$username.trim()) || !(pending !== null && pending !== void 0 && pending.password)) return;
  try {
    var _pending$accountRefer;
    const resp = await store.propertyUtility.getPropertyUtilitiesByPropertyAsync.run({
      propertyId
    });
    const utilities = (resp === null || resp === void 0 ? void 0 : resp.response) || resp || [];
    const match = findCreatedPropertyUtility(Array.isArray(utilities) ? utilities : [], {
      utilityProviderId,
      utilityTypeId
    });
    if (!(match !== null && match !== void 0 && match.propertyUtilityId)) {
      toast('error', {
        body: [SAVE_FAILED]
      });
      return;
    }
    const saved = await store.admin.saveUtilityCredentialAsync.run({
      companyId,
      utilityProviderId,
      propertyId,
      propertyUtilityId: match.propertyUtilityId,
      utilityTypeId,
      accountReference: ((_pending$accountRefer = pending.accountReference) === null || _pending$accountRefer === void 0 ? void 0 : _pending$accountRefer.trim()) || undefined,
      username: pending.username.trim(),
      password: pending.password
    });

    // The caller has already wiped the secret from its ref, so an unreported failure loses the
    // password with no way to retry short of retyping it.
    if (!succeeded(store.admin.saveUtilityCredentialAsync, saved)) {
      toast('error', {
        body: [SAVE_FAILED]
      });
      return;
    }
    notifyCredentialsChanged();
  } catch (error) {
    toast('error', {
      body: [SAVE_FAILED]
    });
  }
};